// extracted by mini-css-extract-plugin
export default {"icon":"zg8a","emblem":"iyvy","SMALL":"HSH0","MEDIUM":"ECVV","LARGE":"fUBI","LARGE_DOUBLE":"mVwk","CIRCLE":"wNLP","SQUARE":"L3Vx"};